import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import VolumeIcon from "@icons/VolumeIcon.svg";
import VolumeMutedIcon from "@icons/VolumeMutedIcon.svg";
import "./LifeAtVolumeToggle.scss";

interface LifeAtVolumeToggleProps {
    volume: number;
    setVolume: (newVol: number) => void;
    label?: string; // label to display next to the icon/image
    overrideIcon?: JSX.Element;
    disabled?: boolean;
    className?: string;
}
/**
 * An abstract volume toggle that can be implemented in multiple places in the
 * application. The icon itself is clickable and will toggle the audio to 0 or 1
 * (full volume). This is primarily intended for Mobile/Tablet users because
 * LifeAtVolumeSlider does not affect the volume setting on their device. They
 * still have to use the volume buttons on the device to set that.
 */
export default function LifeAtVolumeToggle(props: LifeAtVolumeToggleProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const toggleVolumeMuted = () => {
        if (!props.disabled) {
            if (props.volume > 0) {
                props.setVolume(0);
            } else {
                props.setVolume(1);
            }
        }
    };

    let icon;
    if (props.volume > 0) {
        icon = (
            <VolumeIcon className={`volume-toggle-icon ${lightMode ? "light" : "dark"}`} onClick={toggleVolumeMuted} />
        );
    } else {
        icon = (
            <VolumeMutedIcon
                className={`volume-toggle-icon ${lightMode ? "light" : "dark"}`}
                onClick={toggleVolumeMuted}
            />
        );
    }

    return (
        <div className={`lifeat-volume-toggle ${props.className}`}>
            <div className={`volume-toggle-icon-container`} onClick={toggleVolumeMuted}>
                {props.overrideIcon || icon}
            </div>

            {props.label && (
                <span className={`lifeat-volume-toggle-label ${lightMode ? "light" : "dark"}`}>{props.label}</span>
            )}
        </div>
    );
}
